<template>
  <div class="page">
    <!-- Content Section and Navigation Together -->
    <div class="content-wrapper">
      <!-- Content Section -->
      <div class="content-section">
        <div v-for="(item, index) in content.Items" :key="index" class="content-item">
          <div class="card">  
            <div class="card-body">
              <h1 class="title">{{ item.title }}</h1>
              <div v-html="formattedDescriptionNo(item.description_no_1)" class="description_no"></div> 
              <div class="card-header"><img :src="item.image_1" alt="Content Image" class="image" /></div> 
              <div v-html="formattedDescriptionNo(item.description_1)" class="description"></div> 
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Contact Section (always on the right side) -->
    <!-- <div class="contact-container">
      <h2>Contact Information</h2>
      <div class="contact-info">
        <i class="fas fa-phone"></i>
        <p>Phone: +86 19883038871</p>
      </div>
      <div class="contact-info">
        <i class="fas fa-envelope"></i>
        <p>Email: dankao.chen@nxtech.pub</p>
      </div>
    </div> -->
  </div>
</template>

<style src="@/assets/css/news.css" scoped></style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      cn: {
        Items: [
          {
            id: 1,
            image_1: require("@/assets/img/News/002/CeramsiteFactoryPageWallpaper.png"),
            title: "云翰虹章开启新篇章：CG动画展示陶粒板材工厂生产流程",
            description_no_1:`
            `,
            description_1:`
              2022年8月，云翰虹章团队为一家陶粒板材工厂制作了一段CG动画，全面展示了其生产流程细节、产品亮点以及技术底蕴。该项目是云翰虹章自成立以来的首个重大项目，也是云翰虹章的第一桶金。

              近年来，随着全球环境问题的日益严峻，越来越多的公众认识了到环境保护的重要性。因此，在建筑领域，环保材料正逐渐成为市场的主流选择。而陶粒作为一种环保、轻质且高强度的材料，在建筑领域有着广泛的应用潜力。在该背景下，云翰虹章为该工厂定制了一段高品质的CG动画，同时体现了“绿色、创新、高效”的主题。

              为切实满足客户的期望，我们运用了基于虚幻引擎的先进的CG制作技术，为陶粒工厂量身打造了一部高品质的CG动画。借助虚幻引擎卓越的渲染能力和交互设计功能，我们制作的演示片生动地展现了工艺流程的每一个环节，精准地凸显了新生产线的独特优势，并充分地彰显了工厂在技术领域的雄厚实力。通过直观展示设备的内部结构、工作原理及运行状态，我们的CG动画帮助陶粒工厂的目标客户更全面地了解其生产流程和技术底蕴。这种深度展示不仅提升了客户的信任度，还成功助力陶粒工厂拿下了关键订单。

              作为云翰虹章的首个重大项目，该CG动画项目的成功结项不仅标志着公司业务的正式起步，也为未来的发展奠定了坚实的基础。展望未来，云翰虹章将继续秉持创新精神，不断提升科技水平，为客户提供更加优质的服务。
            `,
          },
          // Add more items as needed
        ],
      },
      en: {
        Items: [
          {
            id: 2,
            image_1: require("@/assets/img/News/002/CeramsiteFactoryPageWallpaper.png"),
            title:
              "Rosy Nebula starts a new chapter: CG animation shows the production process of ceramsite factory",
            description_no_1:`
            `,
            description_1:`
              In August 2022, Rosy Nebula made a CG animation that fully demonstrated the details of the production process, product advantages, and technical merits of a ceramsite factory. In addition, this project is Rosy Nebula's first major project since its establishment.

              In recent years, global environmental problems have become increasingly severe, an increasing number of people have recognized the importance of environmental protection. Moreover, environmentally friendly materials like ceramsite are gradually becoming the leading choice in construction. Ceramsite is a lightweight, high-strength, and eco-friendly material with vast application potential. Because of that property, Rosy Nebula made a CG animation demonstration for the factory with the theme of   Green, Innovative and efficient. 

              To meet customers requirements, our technical teams produced a CG animation which was based on Unreal Engine. Leveraging the outstanding rendering capabilities and interactive design features of Unreal Engine, the animation showed every detail in production, the unique advantages of the production line, and demonstrates the factory's strength in the field of technology. 

              By showing the factory's internal structure, working principle, and operating state, clients will enhance their understanding of the workflow of production. This kind of in-depth demonstration will improve customer trust while successfully helping the ceramsite factory secure vital orders. 

              As the first major project of Rosy Nebula, the successful completion symbolizes the official start of the business and thereby lays a solid foundation for future development. In the future, Rosy Nebula will continue to innovate our scientific and technological capabilities to deliver higher-quality service.
            `,
          },
          // Add more items as needed
        ],
      },
    };
  },
  methods: {
    formattedDescription(description) {
      // Apply additional formatting if needed
      return description.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
    formattedDescriptionNo(description_no) {
      // Apply additional formatting if needed
      return description_no.replace(/\n\s*\n/g, '<br /><br />'); // Convert double newlines to paragraph breaks
    },
  },
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },
  watch: {
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
